module.exports = __webpack_public_path__ + "img/11.3adebfa7.jpg";